import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    fontSize: "15px",
    marginBottom: "0",
  };
}

export default function MultipleUpdate({
  setUserIds,
  propEvents,
  personName,
  setPersonName,
  users,
}) {
  const theme = useTheme();
  const [names, setNames] = useState([]);

  useEffect(() => {
    setPersonName([]);
    users.forEach((user) => {
      propEvents.forEach((prop) => {
        if (user._id === prop.eventOff) {
          setPersonName((prev) => [
            ...prev,
            user.firstName + " " + user.lastName,
          ]);
        }
      });
    });

    return () => {
      setPersonName([]);
    };
  }, [users, propEvents, setPersonName]);

  useEffect(() => {
    setNames([]);

    users.forEach((user) => {
      setNames((prev) => [...prev, user?.firstName + " " + user?.lastName]);
    });

    return () => {
      setNames([]);
    };
  }, [users]);

  useEffect(() => {
    setUserIds([]);
    users.forEach((user) => {
      const name = user.firstName + " " + user.lastName;
      personName.forEach((person) => {
        if (name === person) setUserIds((prev) => [...prev, user._id]);
      });
    });

    return () => {
      setUserIds([]);
    };
  }, [personName, users, setUserIds]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="demo-multiple-chip-label">Add Users</InputLabel>
      <Select
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        multiple
        value={personName}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Add Users" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} size="small" />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {names.map((name) => (
          <MenuItem
            key={name}
            value={name}
            style={getStyles(name, personName, theme)}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
